import { Link } from "react-router-dom";
import config from "config/config";
import { isFlagEnabled } from "./utilities";
import { Trans } from "react-i18next";

// PROD, UAT, MO
export const agentChatMainCategories = [
  {
    id: "1",
    name: "Billing & Payments",
    buttonId: "5735G000000ZImg",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_BP",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZAUA4_1873263f978",
  },
  {
    id: "2",
    name: "Commissions",
    buttonId: "5735G000000ZImq",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_Com",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZKUA4_187328706b9",
  },
  {
    id: "3",
    name: "Contract Information",
    buttonId: "5735G000000ZInP",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_PolicyInfo",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZeUAO_18732b10d08",
  },
  {
    id: "4",
    name: "Contract Changes",
    buttonId: "5735G000000ZInK",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_PolicyChange",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZZUA4_18732a945aa",
  },
  {
    id: "5",
    name: "Claims",
    buttonId: "5735G000000ZIml",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_Claims",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZFUA4_18732789e37",
  },
  {
    id: "6",
    name: "Illustrations",
    buttonId: "5735G000000ZIn5",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_Illustrations",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZUUA4_187329f79a1",
  },
  {
    id: "7",
    name: "Disbursements",
    buttonId: "5735G000000ZImv",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_Disbursements",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZPUA4_187329075da",
  },
  {
    id: "8",
    name: "Technical Assistance",
    buttonId: "5735G000000ZInU",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_TechnicalAssistance",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZoUAO_18732c14304",
  },
  ...(isFlagEnabled("ENABLE_ESCALATION_ON_AGENT_PORTAL")
    ? [
        {
          id: "9",
          name: "Escalation",
          buttonId: "5735G000000ZIn0",
          sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_Escalations",
          sfdcESWLiveAgentDevName:
            "EmbeddedServiceLiveAgent_Parent04I5G000000TTZQUA4_1873298b4cf",
        },
      ]
    : []),
  {
    id: "10",
    name: "Something Else",
    buttonId: "5735G000000ZInF",
    sfdcName: "CRM_EVL_Agent_Chat_Embedded_Deployment_SomethingElse",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G000000TTZjUAO_18732b8b25c",
  },
];

export const agentChatSubCategories = {
  "Billing & Payments": [
    {
      id: "0",
      name: "Payment Options",
      message: (
        <>
          <Trans
            i18nKey={"AgentChatSubCategories-billingPayment-paymentOptions"}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Payment History",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-billingPayment-paymentHistory" />
        </>
      ),
    },
    {
      id: "2",
      name: "Making a Payment",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-makePayment"
            components={{
              paymentLink: <Link to="/payment" />,
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "3",
      name: "Recurring Payment Set-up or change",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-recurringPayment"
            components={{
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "4",
      name: "Billing Information",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-billingPayment-billingInformation" />
        </>
      ),
    },
    {
      id: "5",
      name: "Payment Decline",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-billingPayment-paymentDecline" />
        </>
      ),
    },
    {
      id: "6",
      name: "Drafting Issues",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-billingPayment-draftingIssue" />
        </>
      ),
    },
    {
      id: "7",
      name: "Billing Change",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-draftAmountChange"
            components={{
              b: <b></b>,
              br: <br></br>,
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "8",
      name: "Payment History",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-paymentDraftStatus"
            components={{
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "9",
      name: "Stop Payment",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-stopPayment"
            components={{
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "10",
      name: "Approved Refund Information",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-statusOfRefund"
            components={{
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "11",
      name: "Bank Change",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-billingPayment-bankChange" />
        </>
      ),
    },
    {
      id: "12",
      name: "Request a Premium Refund",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-requestPremiumRefund"
            components={{
              b: <b></b>,
              i: <i></i>,
            }}
          />
        </>
      ),
    },
    {
      id: "13",
      name: "Received Payment Due Notice",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-receivedPaymentDueNotice"
            components={{
              b: <b></b>,
              br: <br></br>,
              paymentLink: <Link to="/payment" />,
            }}
          />
        </>
      ),
    },
    {
      id: "14",
      name: "Late Payment/Lapse Notice",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-billingPayment-latePaymentNotice"
            components={{
              b: <b></b>,
              br: <br></br>,
              paymentLink: <Link to="/payment" />,
            }}
          />
        </>
      ),
    },
  ],
  Commissions: [
    {
      id: "0",
      name: "Chargeback Related Questions",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-commissions-chargeBackRelatedQuestion"
            components={{
              commissionLink: <Link to="/commissions" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Payment History",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-commissions-paymentHistory"
            components={{
              commissionLink: <Link to="/commissions" />,
            }}
          />
        </>
      ),
    },
  ],
  "Contract Information": [
    {
      id: "0",
      name: "Rates/Premium/Renewal Information",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-contractInfo-renewalInfo" />
        </>
      ),
    },
    {
      id: "1",
      name: "Contract Coverage/Riders/Issue date",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-contractInfo-riderIssueDate" />
        </>
      ),
    },
    {
      id: "2",
      name: "Beneficiary on Contract",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-contractInfo-contractBeneficiary" />
        </>
      ),
    },
    {
      id: "3",
      name: "Contract Value - Surrender/Current",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-contractInfo-contractValue" />
        </>
      ),
    },
    {
      id: "4",
      name: "Annual Statement",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractInfo-annualStatement"
            components={{
              commissionLink: <Link to="/commissions" />,
            }}
          />
        </>
      ),
    },
  ],
  "Contract Changes": [
    {
      id: "0",
      name: "Request Change - Beneficiary ",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractChanges-requestChangeBeneficiary"
            components={{
              b: <b></b>,
              formLink: <Link to="/services-claims/forms" />,
              helpLink: <Link to="/help" />,
            }}
          />
        </>
      ),
    },
    // {
    //   id: "",
    //   name: "Request Change - Contract Processing Guidelines",
    //   message: (
    //     <>
    //       You can view the Contract Processing Guidelines in the FAQ section of
    //       the Agent Portal by clicking <Link to="/help/faqs">here</Link>
    //     </>
    //   ),
    // },
    {
      id: "1",
      name: "Request change - Address/Phone",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractChanges-requestChangeMobilePhone"
            components={{
              b: <b></b>,
              formLink: <Link to="/services-claims/forms" />,
              helpLink: <Link to="/help" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Request Change - Name/Owner",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractChanges-requestChangeName"
            components={{
              b: <b></b>,
              formLink: <Link to="/services-claims/forms" />,
              helpLink: <Link to="/help" />,
            }}
          />
        </>
      ),
    },
    {
      id: "3",
      name: "3rd Party Information Authorization",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractChanges-3rdPartyInfo"
            components={{
              b: <b></b>,
              formLink: <Link to="/services-claims/forms" />,
              helpLink: <Link to="/help" />,
            }}
          />
        </>
      ),
    },
    {
      id: "4",
      name: "Request Duplicate Contract Pages",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-contractChanges-requestDuplicateContract" />
        </>
      ),
    },
    {
      id: "5",
      name: "Status of Pending Request",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-contractChanges-statusPendingRequest"
            components={{
              servicesLink: <Link to="/services-claims" />,
            }}
          />
        </>
      ),
    },
    // {
    //   id: "",
    //   name: "Reinstatement requirements",
    //   message: (
    //     <>
    //       You can view the Reinstatement Requirements in the FAQ section of the
    //       Agent Portal by clicking <Link to="/help/faqs">here</Link>
    //     </>
    //   ),
    // },
    // {
    //   id: "",
    //   name: "Status of Reinstatement",
    //   message: (
    //     <>
    //       You can view the status of the customer Reinstatement Request in the
    //       Agent Portal on the Services & Claims page under the Service Request &
    //       Claims section <Link to="/services-claims">here</Link>
    //     </>
    //   ),
    // },
    // {
    //   id: "",
    //   name: "Cancellation Request",
    //   message: (
    //     <>
    //       You can view the status of the customer Cancellation Request in the
    //       Agent Portal on the Services & Claims page under the Service Request &
    //       Claims section <Link to="/services-claims">here</Link>
    //     </>
    //   ),
    // },
    // {
    //   id: "",
    //   name: "Premium Change",
    //   message: (
    //     <>
    //       You can view the status of the customer Policy Change Request in the
    //       Agent Portal on the Services & Claims page under the Service Request &
    //       Claims section <Link to="/services-claims">here</Link>
    //     </>
    //   ),
    // },
    // {
    //   id: "",
    //   name: "Statement of Insurance",
    //   message: (
    //     <>
    //       You can view the status of the customer Policy Change Request in the
    //       Agent Portal on the Services & Claims page under the Service Request &
    //       Claims section <Link to="/services-claims">here</Link>
    //     </>
    //   ),
    // },
  ],
  Claims: [
    {
      id: "0",
      name: "How to File a Claim",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-claims-submitClaim"
            components={{
              fileAClaimLink: <Link to="services-claims/claims/file-a-claim" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Claim Forms",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-claims-claimForm"
            components={{
              fileAClaimLink: <Link to="services-claims/claims/file-a-claim" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Status of a Claim",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-claims-claimStatus"
            components={{
              servicesLink: <Link to="/services-claims" />,
            }}
          />
        </>
      ),
    },
  ],
  Illustrations: [
    {
      id: "0",
      name: "Status of Request",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-illustration-statusOfRequest" />
        </>
      ),
    },
    {
      id: "1",
      name: "Understanding how to Run Illustration",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-illustration-runIllustration" />
        </>
      ),
    },
  ],
  Disbursements: [
    {
      id: "0",
      name: "Inquiry about Loan",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-disbursements-loanInquiry" />
        </>
      ),
    },
    {
      id: "1",
      name: "Loan Balance",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-disbursements-loanBalance" />
        </>
      ),
    },
    {
      id: "2",
      name: "Surrender History",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-disbursements-surrenderHistory" />
        </>
      ),
    },
    {
      id: "3",
      name: "Surrender Options",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-disbursements-surrenderOptions" />
        </>
      ),
    },
    {
      id: "4",
      name: "Request for Distribution",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-disbursements-requestDistribution" />
        </>
      ),
    },
  ],
  "Technical Assistance": [
    {
      id: "0",
      name: "Navigation Questions",
      message: (
        <>
          <Trans i18nKey="AgentChatSubCategories-technicalAssistance-navigationQuestions" />
        </>
      ),
    },
    {
      id: "1",
      name: "How to Reset Password",
      message: (
        <>
          <Trans
            i18nKey="AgentChatSubCategories-technicalAssistance-resetPassword"
            components={{
              profileLink: <Link to="/profile" />,
            }}
          />
        </>
      ),
    },
  ],
  Escalation: [],
  "Something Else": [],
};

export const customerChatMainCategories = [
  {
    id: "1",
    name: "Billing & Payments",
    buttonId: "5735G000000QzwK",
    sfdcName: "EVL_Customer_Billing_Payments",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPbUAM_18f2373dd33",
  },
  {
    id: "2",
    name: "Contract Information",
    buttonId: "5735G000000Qzwe",
    sfdcName: "EVL_Customer_Policy_Information",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPfUAM_18f237879ba",
  },
  {
    id: "3",
    name: "Contract Changes",
    buttonId: "5735G000000QzwZ",
    sfdcName: "EVL_Customer_Policy_Changes",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPeUAM_18f2377cef0",
  },
  {
    id: "4",
    name: "Claims",
    buttonId: "5735G000000QzwP",
    sfdcName: "EVL_Customer_Claims",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPcUAM_18f2375bb57",
  },
  {
    id: "5",
    name: "Disbursements",
    buttonId: "5735G000000QzwU",
    sfdcName: "EVL_Customer_Disbursements",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPdUAM_18f23773316",
  },
  {
    id: "6",
    name: "Technical Assistance",
    buttonId: "5735G000000Qzwo",
    sfdcName: "EVL_Customer_Technical_Assistance",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPhUAM_18f2379d4ff",
  },
  {
    id: "7",
    name: "Something Else",
    buttonId: "5735G000000Qzwj",
    sfdcName: "EVL_Customer_Something_Else",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPgUAM_18f2379158c",
  },
];

export const customerChatMainCategoriesAnnuity = [
  {
    id: "1",
    name: "Billing & Payments",
    buttonId: "573UL0000001e3R",
    sfdcName: "EVL_Customer_BP_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdJ2AS_19294c544b1",
  },
  {
    id: "2",
    name: "Contract Information",
    buttonId: "573UL0000001e8H",
    sfdcName: "EVL_Customer_Policy_Information_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdN2AS_19294c36021",
  },
  {
    id: "3",
    name: "Contract Changes",
    buttonId: "573UL0000001e6f",
    sfdcName: "EVL_Customer_Policy_Changes_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdM2AS_19294c0c30f",
  },
  {
    id: "4",
    name: "Claims",
    buttonId: "573UL0000001eBV",
    sfdcName: "EVL_Customer_Claims_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdK2AS_19294c5e955",
  },
  {
    id: "5",
    name: "Disbursements",
    buttonId: "573UL0000001e53",
    sfdcName: "EVL_Customer_Disbursements_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdL2AS_19294c05c9d",
  },
  {
    id: "6",
    name: "Technical Assistance",
    buttonId: "5735G000000Qzwo",
    sfdcName: "EVL_Customer_Technical_Assistance",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04I5G0000008VPhUAM_18f2379d4ff",
  },
  {
    id: "7",
    name: "Something Else",
    buttonId: "573UL0000001e9t",
    sfdcName: "EVL_Customer_Something_Else_Annuity",
    sfdcESWLiveAgentDevName:
      "EmbeddedServiceLiveAgent_Parent04IUL000000AzdO2AS_19294c4853d",
  },
];

export const customerChatSubCategories = {
  "Billing & Payments": [
    {
      id: "0",
      name: "Payment Options",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-paymentOptions"
            components={{
              paymentLink: <Link to="/payment" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Payment History",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-paymentHistory"
            components={{
              billingLink: <Link to="/payment/billing" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Making a Payment",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-makePayment" />
        </>
      ),
    },
    {
      id: "3",
      name: "Recurring Payment Set Up or Change",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-recurringPayment" />
        </>
      ),
    },
    {
      id: "4",
      name: "Billing Information",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-billingInformation"
            components={{
              paymentLink: <Link to="/payment" />,
            }}
          />
        </>
      ),
    },
    {
      id: "5",
      name: "Payment Decline",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-paymentDecline" />
        </>
      ),
    },
    {
      id: "6",
      name: "Drafting Issues",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-draftingIssue" />
        </>
      ),
    },
    {
      id: "7",
      name: "Billing Change",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-billingChange"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "8",
      name: "Payment History",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-paymentHistory1"
            components={{
              billingLink: <Link to="/payment/billing" />,
            }}
          />
        </>
      ),
    },
    {
      id: "9",
      name: "Stop Payment",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-stopPayment" />
        </>
      ),
    },
    {
      id: "10",
      name: "Approved Refund Information",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-approvedRefundInfo"
            components={{
              billingLink: <Link to="/payment/billing" />,
            }}
          />
        </>
      ),
    },
    {
      id: "11",
      name: "Bank Change",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-bankChange"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "12",
      name: "Received Payment Due Notice",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-receivedPayment" />
        </>
      ),
    },
    {
      id: "13",
      name: "Lapse Notice",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-billingPayment-lapseNotice" />
        </>
      ),
    },
    {
      id: "14",
      name: "Late Payment",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-billingPayment-latePayment"
            components={{
              makeAPaymentLink: <Link to="/payment/make-a-payment" />,
            }}
          />
        </>
      ),
    },
  ],
  "Contract Information": [
    {
      id: "0",
      name: "Rates/Premium/Renewal Information",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractInfo-renewalInfo"
            components={{
              policiesLink: <Link to="/policies" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Contract Coverage/Riders/Issue Date",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractInfo-issueDate"
            components={{
              policiesLink: <Link to="/policies" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Beneficiary on Contract",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractInfo-contractBeneficiary"
            components={{
              policiesLink: <Link to="/policies" />,
            }}
          />
        </>
      ),
    },
    {
      id: "3",
      name: "Contract Value - Surrender/Current",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractInfo-contractValue"
            components={{
              policiesLink: <Link to="/policies" />,
            }}
          />
        </>
      ),
    },
    {
      id: "4",
      name: "Annual Statement",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractInfo-annualStatement"
            components={{
              messagesLink: <Link to="/messages" />,
            }}
          />
        </>
      ),
    },
  ],
  "Contract Changes": [
    {
      id: "0",
      name: "Request Change - Beneficiary",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractChange-changeBeneficiary"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Request Change - Address/Phone",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractChange-changeAddress"
            components={{
              profileLink: <Link to="/profile" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Request Change - Name/Owner",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractChange-changeOwner"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "3",
      name: "3rd Party Information Authorization",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractChange-3rdPartyInfo"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "4",
      name: "Request Duplicate Contract Pages",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-contractChange-requestDuplicateContract"
            components={{
              formLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
    {
      id: "5",
      name: "Status of Pending Request",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-contractChange-pendingRequestStatus" />
        </>
      ),
    },
  ],
  Claims: [
    {
      id: "0",
      name: "How to File a Claim",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-claims-fileAClaim"
            components={{
              claimLink: <Link to="/services-claims/claims" />,
            }}
          />
        </>
      ),
    },
    {
      id: "1",
      name: "Status of a Claim",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-claims-claimStatus"
            components={{
              policiesLink: <Link to="policies" />,
            }}
          />
        </>
      ),
    },
  ],
  Disbursements: [
    {
      id: "0",
      name: "Inquiry About Loan",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-disbursements-loanInquiry" />
        </>
      ),
    },
    {
      id: "1",
      name: "Loan Balance",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-disbursements-loanBalance"
            components={{
              policiesLink: <Link to="policies" />,
            }}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Surrender History",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-disbursements-surrenderHistory"
            components={{
              policiesLink: <Link to="policies" />,
              billingLink: <Link to="/payment/billing" />,
            }}
          />
        </>
      ),
    },
    {
      id: "3",
      name: "Surrender Options",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-disbursements-surrenderOptions" />
        </>
      ),
    },
    {
      id: "4",
      name: "Request for Distribution",
      message: (
        <>
          <Trans
            i18nKey="CustomerChatSubCategories-disbursements-requestDistribution"
            components={{
              formsLink: <Link to="/services-claims/forms" />,
            }}
          />
        </>
      ),
    },
  ],
  "Technical Assistance": [
    {
      id: "0",
      name: "Navigation Questions",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-technicalAssistance-navigationQuestions" />
        </>
      ),
    },
    {
      id: "1",
      name: "How to Reset Password",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-technicalAssistance-resetPassword" />
        </>
      ),
    },
  ],
  "Something Else": [
    {
      id: "0",
      name: "HIDDEN",
      message: (
        <>
          <Trans i18nKey="CustomerChatSubCategories-somethingElse-hidden" />
        </>
      ),
    },
  ],
};
